export type CategorySelectionPath = 'browse' | 'search_results' | 'suggested';

/** Idle pause before a category search with nothing to pick is reported. */
export const CATEGORY_SEARCH_NO_RESULTS_IDLE_MS = 1000;

const CATEGORY_SEARCH_TERM_MAX_LENGTH = 50;
const OTHER_CATEGORY_NAME = 'other';

/** Trim, lowercase, and cap a category search. Empty input becomes null. */
export const normalizeCategorySearchTerm = (raw: string | null | undefined): string | null => {
  if (raw == null) {
    return null;
  }

  const normalized = raw.trim().toLowerCase().slice(0, CATEGORY_SEARCH_TERM_MAX_LENGTH);

  return normalized.length > 0 ? normalized : null;
};

export const isOtherCategoryName = (name?: string | null): boolean =>
  name?.trim().toLowerCase() === OTHER_CATEGORY_NAME;
